export class AuthV2AssociateSoftwareTokenRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "session",
            "baseName": "session",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuthV2AssociateSoftwareTokenRequest.attributeTypeMap;
    }
    constructor() {
    }
}
